import React from 'react';
import styled from 'styled-components';

import Paper from '@mui/material/Paper';

import { useDebriefApp } from 'ff/debrief/hooks';
import SegmentDetailsPanel from 'ff/debrief/layouts/SegmentDetailsPanel';
import OverallScoreBar from 'ff/debrief/components/segments/OverallScoreBar';

import ScoringDetailsTitle from './ScoringDetailsTitle';
import ScoreBreakDown from './ScoreBreakDown';

const ScoringDetails = () => {
    const { selectedSegment, isHidingSegmentDetails, hideScoreDetails } =
        useDebriefApp();
    if (
        selectedSegment?.scoringDetails === undefined ||
        selectedSegment?.scoringDetails?.length === 0 ||
        isHidingSegmentDetails
    )
        return null;
    return (
        <SegmentDetailsPanel>
            <SegmentDetailsSurface sx={{ p: 1 }}>
                <ScoringDetailsTitle
                    segmentLabel={selectedSegment.label}
                    onCloseButtonClick={hideScoreDetails}
                />
                <OverallScoreBar
                    score={selectedSegment.score}
                    sx={{ p: 1, mb: 2 }}
                />
                <ScoreBreakDown scoreDetails={selectedSegment.scoringDetails} />
            </SegmentDetailsSurface>
        </SegmentDetailsPanel>
    );
};

const SegmentDetailsSurface = styled(Paper)`
    width: 100%;
`;

export default ScoringDetails;
